import gql from 'graphql-tag';

export const mutationUpdateAccountSubscription = gql`
  mutation updateAccountSubscription(
    $licensedUserCount: Int
  ) {
    updateAccountSubscription(
      licensedUserCount: $licensedUserCount
    )
  }
`;
export default mutationUpdateAccountSubscription;
